import { FC } from "react";
import { useDispatch } from "react-redux";
import type { AppDispatch } from "store";
import { TrashIcon, EyeIcon, EyeOffIcon } from "shared/ui";
import {
  removeIndicatorThunk,
  saveIndicatorSettingsThunk,
  toggleIndicatorVisibilityThunk,
} from "../../model";
import styles from "./IndicatorSettingsModal.module.css";

interface Props {
  instanceId: string;
  isVisible: boolean;
  onClose: () => void;
}

export const IndicatorSettingsFooter: FC<Props> = ({ instanceId, isVisible, onClose }) => {
  const dispatch = useDispatch<AppDispatch>();

  const handleDelete = () => {
    dispatch(removeIndicatorThunk(instanceId));
    onClose();
  };

  const handleSave = () => {
    dispatch(saveIndicatorSettingsThunk(instanceId));
    onClose();
  };

  return (
    <div className={styles.footer}>
      <button className={styles.deleteBtn} onClick={handleDelete} title="Delete">
        <TrashIcon />
      </button>
      <button
        className={styles.iconBtn}
        onClick={() => dispatch(toggleIndicatorVisibilityThunk(instanceId))}
        title={isVisible ? "Hide" : "Show"}
      >
        {isVisible ? <EyeIcon /> : <EyeOffIcon />}
      </button>
      <button className={styles.saveBtn} onClick={handleSave}>
        Save
      </button>
    </div>
  );
};
